<template>
  <Modules class="result" :pageModules="pageModulesListResult" />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { PageModule, PageModuleData } from '../../types'

@Component({
  components: {
  }
})
export default class Result extends Vue {
  @Getter pageModulesListResult!: PageModule<PageModuleData>
  @Getter campaignSetlistUserPlaylistId!: string;
  @Action('GO_TO_FIRST_STEP') goToFirstStep!: () => void
  @Action('CAMPAIGN_GET_SETLIST') campaignGetSetlist!: () => Promise<void>

  async created () {
    console.log('Current user playlist id: ', this.campaignSetlistUserPlaylistId)
    if (!this.campaignSetlistUserPlaylistId) {
      console.log('There is no playlist, redirecting to first step')
      this.goToFirstStep()
    }
    await this.campaignGetSetlist()
  }
}
</script>
